export function eexCredentialStorePayload(
  token: string,
  expiresAtLocal?: string
): { token: string; tokenExpiresAt?: string } {
  const payload: { token: string; tokenExpiresAt?: string } = { token: token.trim() };
  const normalizedExpiry = expiresAtLocal?.trim();
  if (!normalizedExpiry) return payload;

  const expiry = new Date(normalizedExpiry);
  if (!Number.isFinite(expiry.getTime())) {
    throw new Error("Credential expiry is not a valid date and time");
  }
  payload.tokenExpiresAt = expiry.toISOString();
  return payload;
}

export function canToggleEexDatasourceConnection(input: {
  enabled: boolean;
  masterEnabled: boolean;
  workerAvailable: boolean;
  credentialCanEnable: boolean;
}): boolean {
  // Disabling is an emergency-safe local operation and must remain available
  // even if the global switch or worker is down.
  if (input.enabled) return true;
  return input.masterEnabled && input.workerAvailable && input.credentialCanEnable;
}

export type EexDatasourceTestControls = {
  masterEnabled: boolean;
  workerAvailable: boolean;
  configured: boolean;
  pendingReplacement: boolean;
  quotaPrincipalAttested: boolean;
  pendingQuotaPrincipalAttested: boolean;
  testInProgress: boolean;
  pendingTestInProgress: boolean;
  activeExpiryState?: "unknown" | "valid" | "expiring_soon" | "expired";
  pendingExpiryState?: "unknown" | "valid" | "expiring_soon" | "expired";
};

export function canTestEexDatasourceConnection(input: EexDatasourceTestControls): boolean {
  if (!input.masterEnabled || !input.workerAvailable || !input.configured) return false;
  return input.pendingReplacement
    ? input.pendingQuotaPrincipalAttested &&
        input.pendingExpiryState !== "expired" &&
        !input.pendingTestInProgress
    : input.quotaPrincipalAttested && input.activeExpiryState !== "expired" && !input.testInProgress;
}

export function canPromotePendingEexCredential(input: {
  pendingReplacement: boolean;
  pendingQuotaPrincipalAttested: boolean;
  pendingLastTestStatus: string | null;
  pendingTestInProgress: boolean;
  pendingExpiryState?: "unknown" | "valid" | "expiring_soon" | "expired";
}): boolean {
  return (
    input.pendingReplacement &&
    input.pendingQuotaPrincipalAttested &&
    input.pendingExpiryState !== "expired" &&
    input.pendingLastTestStatus === "ok" &&
    !input.pendingTestInProgress
  );
}

export function eexConnectionTestIsActive(input: {
  testInProgress: boolean;
  pendingTestInProgress: boolean;
}): boolean {
  return input.testInProgress || input.pendingTestInProgress;
}
